<template>
    <div>
        <div class="FA_Ques_Top">
            <div class="Ques_Top_Banner">
                <img src="https://resource.rcclchina.com.cn/content/FAQ/FA_Banner2.png">
            </div>
        </div>
        <div class="faDetail">
            <div class="faDetail-content">
                <div class="faDetail-qaCon">
                    <div class="faDetail-question" v-html="faq.question">
                    
                    </div>
                    <div class="faDetail-answer" v-html="faq.answer">
                        
                    </div>
                    <FaqFeedback 
                        :faq="faq"
                        :selectedShipCategory="shipCategory"
                        :onFaqFeedbackSuccess="onFaqFeedbackSuccess"
                        class="faqDetailFeedback"
                    />
                </div>
                <div class="rcclQN__recommend">
                    <PromoCruise />
                </div>
            </div>
            
        </div>
        
    </div>
</template>

<script>
import api from '@/api'
const FaqFeedback = () => import('@/components/Faq/FaqFeedback')
const PromoCruise = () => import('@/components/Cruise/PromoCruise')
export default {
    name: "FaqDetail",
    components: {
        FaqFeedback,
        PromoCruise
    },
    data () {
        return {
            shipCategory: {},
            faq: {}
        }
    },
    beforeMount () {
        this.initPage()
    },
    methods: {
        async initPage() {
            const { id } = this.$router.currentRoute.params
            if (!id || id < 0) {
                return this.$router.push('/content/faq')
            }
            const { shipCategory, shipSubCategory} = this.$router.currentRoute.query
            this.shipCategory = {
                title: shipCategory || "",
                subTitle: shipSubCategory || ""
            }

            const rewardToken = this.$store.state.user.userReviewToken
            const { success, data } = await api.page.getFaqById({
                faqId: id,
                shipSubCategory,
                shipCategory,
                userName: rewardToken
            })

            if (!success || !data) {
                return this.$router.push('/content/faq')
            } else {
                this.faq = data
            }

        },
        onFaqFeedbackSuccess (faqId, type) {
            this.faq.suggestionType = type
        }
    }
}
</script>

<style lang="less" scoped>
* {
    padding:0;
    margin:0;
}
ul, li {
    list-style:none;
}

/*** FA_Ques_Top ***/


.FA_Ques_Top .Ques_Top_Banner img{
  width: 100%;
}
.FA_Ques_Top{
  position: relative;
}
.FA_Ques_Search .search_Ques_Button{
  position: absolute;
  bottom: 5%;
  margin: 0 auto;
}
.FA_Ques_Top .FA_Ques_Search .textInput1,.FA_Ques_Top .FA_Ques_Search .textInput2,
.FA_Ques_Top .FA_Ques_Search .textInput3{
  height: 40px;
}
.FA_Ques_Top .FA_Ques_Search .textInput2{
  width: 135px;
}
.FA_Ques_Top .FA_Ques_Search .textInput2:hover{
  background: #fff;
}
.FA_Ques_Top .FA_Ques_Search .textInput3{
  margin-top: -2px;
}
.FA_Ques_Top .FA_Ques_Search .textInput1{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.FA_Ques_Top .FA_Ques_Search .textInput3{
  width: 95px;
  background-color: #fbc300;
  color: #fff;
  font-size: 20px;
}
.FA_Ques_Top .FA_Ques_Search .textBorder{
  padding: 0;
  border: 10px solid #2c231e;
}
.both{
  clear: both;
}
.sor{
  background: #000f57;
}

/*全部下拉*/
.dropdown-menu.pull-right{
  right: 90px;
}
.All_list{
  min-width: 135px;
}
.All_list li{
  height: 40px;
  border:1px solid #eaeaea;
  width: 100%;
}
.All_list li a{
  height: 100%;
  line-height: 20px;
  cursor:pointer;
}

/**** 常见问题详情 ****/
.faDetail {
    background-color:#f5f5f5;
    padding:30px 0;
}
.faDetail-content {
    width: 90%;
    margin: 0 auto;
}
.faDetail-qaCon {
    padding: 44px 20px;
    background-color: #fff;
    border-radius: 4px;
    position:relative;
}
.faDetail-content  .faDetail-question {
    font-size:14px;
    color:#000;
    border-bottom:1px dashed #ddd;
    padding-bottom:14px;
}
.faDetail-content .faDetail-question p,
.faDetail-content .faDetail-question span{
    font-size: 14px !important;
    color: #000;
}
.faDetail-content  .faDetail-answer {
    margin-top:15px;
    font-size:13px;
    color:#646464; 
}
.faDetail-content .faDetail-answer p>img{
    width:100%;
    height:auto;
}
.faDetail-useInfo .useInfo-closedBtn {
    position: absolute;
    top: -5%;
    right: -5%;
    cursor: pointer;
}

/**** 可能感兴趣的问题 ****/
.interestQues {
    margin-top: 10px;
    padding: 44px 20px;
    background-color: #fff;
    border-radius: 4px;
}
.interestQues .interestQues-title{
    font-size:14px;
    color:#000;
    border-bottom:1px solid #ddd;
    padding-bottom:24px;
}
.interestQues .interestQues-con{
    margin-top:14px;
}
.interestQues .interestQues-con ul{
    overflow:hidden;
}
.interestQues .interestQues-con ul li{
    width:32%;
    height:52px;
    line-height:52px;
    float:left;
    border-bottom:1px dashed #ddd;
    padding-left:2%;
}
.interestQues .interestQues-con ul li:nth-child(3n+2){
    margin:0 2%;
}
.interestQues .interestQues-con ul li a{
    color:#0066b6;
    font-size:12px;
}
</style>

<style lang="less">
.faDetail-useInfo .useInfo-choice>div {
    background-color: #ececec;
}

.faDetail {
    .rcclQN__recommend {
        width: 100%;
        .or_line_con{
            width: 1280px;
            margin: 20px auto;
        }
    }
}
</style>